import { supabase } from "src/lib/supabaseClient";

export interface User {
  id: string;
  email: string;
  created_at: string;
  last_sign_in_at: string | null;
  role: string | null;
  first_name: string | null;
  last_name: string | null;
  status: string | null;
}

export interface UsersResponse {
  users: User[];
  total: number;
}

export const fetchUsers = async (): Promise<UsersResponse> => {
  try {
    // Query to join auth.users with public.profiles
    // Note: We need to use a database function or RPC call since we can't directly query auth.users from the client
    const { data, error } = await supabase.rpc('get_all_users');

    if (error) {
      console.error("Error fetching users:", error);
      throw new Error(error.message);
    }

    return {
      users: data || [],
      total: data?.length || 0
    };
  } catch (error) {
    console.error("Failed to fetch users:", error);
    throw error;
  }
};

export const deleteUser = async (userId: string): Promise<void> => {
  try {
    // Call a database function to delete user from auth.users
    const { error } = await supabase.rpc('delete_user', { user_id: userId });

    if (error) {
      console.error("Error deleting user:", error);
      throw new Error(error.message);
    }
  } catch (error) {
    console.error("Failed to delete user:", error);
    throw error;
  }
};

export default {
  fetchUsers,
  deleteUser,
};